import VueRouter, { RouteConfig } from 'vue-router'

const List = () => import('../views/CompetitionRegionJudgeList.vue')
const Edit = () => import('../views/CompetitionRegionJudgeEdit.vue')
const Details = () => import('../views/CompetitionRegionJudgeDetails.vue')

const Score = () => import('../views/CompetitionRegionJudgeScore.vue')
const JudgeStats = () => import('../views/CompetitionRegionStatsJudge.vue')

export const listRoute: RouteConfig = {
  path: 'judge-list',
  name: 'competition_region_judge_list',
  component: List,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '区域云比赛',
  },
}

export const editRoute: RouteConfig = {
  path: 'judge-edit',
  name: 'competition_region_judge_edit',
  component: Edit,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '区域云比赛',
  },
}

export const detailsRoute: RouteConfig = {
  path: 'judge-details',
  name: 'competition_region_judge_details',
  component: Details,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '区域云比赛',
  },
}

export const scoreRoute: RouteConfig = {
  path: 'judge-score',
  name: 'competition_region_judge_score',
  component: Score,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '区域云比赛',
  },
}

export const statsRoute: RouteConfig = {
  path: 'judge-stats',
  name: 'competition_region_organization_judge_stats',
  component: JudgeStats,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '区域云比赛',
  },
}

export default [listRoute, editRoute, detailsRoute, scoreRoute, statsRoute]

export function navigateToCompetitionRegionJudgeList(router: VueRouter, competitionId: string) {
  router.push({ path: `../${listRoute.path}`, query: { competitionId } })
}

export function navigateToCompetitionRegionJudgeEdit(router: VueRouter) {
  router.push({ path: editRoute.path })
}

export function navigateToCompetitionRegionJudgeDetails(router: VueRouter, id: string, competitionId: string) {
  router.push({ path: detailsRoute.path, query: { id, competitionId } })
}

export function navigateToCompetitionRegionJudgeScore(
  router: VueRouter,
  id: string,
  groupName: string,
  scoringTypesId: string
) {
  router.push({ path: `../${scoreRoute.path}`, query: { id, groupName, scoringTypesId } })
}

export function navigateToCompetitionRegionJudgeStats(router: VueRouter, id: string, name: string, groupCode: string) {
  router.push({ path: `../${statsRoute.path}`, query: { id, name, groupCode } })
}
